import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getIn } from 'formik';
import {
  Box,
  InputFeedback,
  InputGroup,
  Text,
  Checkbox
} from '@components/common';

const FieldGroup = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 0;
  box-shadow: inset 0px 3px 5px 0px rgba(0, 0, 0, 0.1),
    inset 0px 0px 1px 1px rgba(0, 0, 0, 0.15);
`;

const CheckboxContainer = styled.label`
  width: 52px;
  height: 52px;
  padding: 16px;
`;

// Todo: error status
function CheckboxField(props) {
  const { field, label, form, fontSize, renderAddon, ...rest } = props;
  const formError = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const hasError = !!(touched && formError);

  return (
    <InputGroup>
      <FieldGroup borderRadius={4} borderWidth={0} pl={4} pr={0} {...rest}>
        <Text fontSize={fontSize === undefined ? 1 : fontSize} mr={2}>
          {label}
        </Text>
        <CheckboxContainer>
          <Checkbox
            mb={0}
            type="checkbox"
            fontSize={2}
            error={hasError}
            disabled={form.isSubmitting}
            {...field}
          />
        </CheckboxContainer>
      </FieldGroup>

      {renderAddon && renderAddon()}
      {hasError && <InputFeedback>{formError}</InputFeedback>}
    </InputGroup>
  );
}

CheckboxField.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
  label: PropTypes.string,
  renderAddon: PropTypes.func,
  fontSize: PropTypes.number
};

export default CheckboxField;
